import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from 'react-i18next'
import { AuthContext } from 'src/contexts/authContext'
const AuthorizedHeadContent = () => {

  const { t } = useTranslation()
  const { systemSettings, userInfo } = useContext(AuthContext)

  return (
    <Helmet>
      <meta name="description" content="Devis" />
      <meta name="author" content="Cubotoo" />
      <meta name="keyword" content="Cubotoo, tender, devis" />
      <link rel="shortcut icon" href={`${ systemSettings?.replaceLogoPerTenderOffice ? "/cubotoo-logo.png" : "/favicon.ico"}`} />
      <title>{`${systemSettings?.replaceWordingPerTenderOffice ? `${ userInfo?.departmentsNames?.length ? userInfo.departmentsNames[0] : t('PageTitle') }`: "Devis@HGC"}`}</title>
    </Helmet>
  );
};

export default AuthorizedHeadContent;
